import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export default function useInvalidateQueryOnUnmount(queryKey: string) {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.invalidateQueries({ queryKey: [queryKey] });
    };
  }, [queryClient, queryKey]);
}
